import { isEnquiryInDateRange } from "./enquiry-date";
import type { EnquiryDateRangeFilter } from "./enquiry-date-range";
import { hasActiveDateRange } from "./enquiry-date-range";
import { resolveEnquiryFormType } from "./enquiry-form-type";
import { displayCategory, displayFormType, parseEnquiryMore, type EnquiryRow } from "./enquiry-helpers";

export type EnquiryFormFilter = "all" | "services" | "careers" | "leads";

export const hasActiveEnquiryFilters = (
    query: string,
    formFilter: EnquiryFormFilter,
    dateRange: EnquiryDateRangeFilter
) => Boolean(query.trim()) || formFilter !== "all" || hasActiveDateRange(dateRange);

export const filterEnquiries = (
    rows: EnquiryRow[],
    query: string,
    formFilter: EnquiryFormFilter,
    dateRange: EnquiryDateRangeFilter
) => {
    const safeRows = Array.isArray(rows) ? rows : [];
    const normalizedQuery = query.trim().toLowerCase();

    return safeRows.filter((row) => {
        const formType = resolveEnquiryFormType(row);
        if (formFilter !== "all" && formType !== formFilter) return false;
        if (!isEnquiryInDateRange(row.timestamp, dateRange)) return false;
        if (!normalizedQuery) return true;

        const haystack = [
            row.name,
            row.phoneno,
            row.email,
            row.location,
            row.message,
            row.category,
            displayCategory(row),
            displayFormType(row),
            formType,
        ]
            .filter(Boolean)
            .join(" ")
            .toLowerCase();

        return haystack.includes(normalizedQuery);
    });
};

export const getEnquiryStats = (rows: EnquiryRow[]) => {
    const safeRows = Array.isArray(rows) ? rows : [];
    let services = 0;
    let careers = 0;
    let leads = 0;

    safeRows.forEach((row) => {
        const formType = resolveEnquiryFormType(row);
        if (formType === "services") services += 1;
        if (formType === "careers") careers += 1;
        if (formType === "leads") leads += 1;
    });

    return { total: safeRows.length, services, careers, leads };
};
